const BULLET_CHAR = '•';
const WHITE_SPACE_CHAR = ' ';
const DASH_CHAR = '-';

export function capitalize(string = '') {
  if (!string) {
    return '';
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function capitaliseWords(string = '', spaceChar = WHITE_SPACE_CHAR) {
  if (!string) {
    return '';
  }

  return string.toLowerCase().split(spaceChar).map(capitalize).join(WHITE_SPACE_CHAR);
}

export function setenceWords(string = '', spaceChar = WHITE_SPACE_CHAR) {
  if (!string) {
    return '';
  }

  return string
    .toLowerCase()
    .split(spaceChar)
    .map((word, index) => (index > 0 ? word : capitalize(word)))
    .join(WHITE_SPACE_CHAR);
}

export function replaceDashByBulletChar(string = '') {
  return string?.replace(DASH_CHAR, BULLET_CHAR) ?? '';
}

export function joinStringsWithBullet(...strings) {
  return (
    strings
      ?.filter((string) => string !== '')
      .join(`${WHITE_SPACE_CHAR}${BULLET_CHAR}${WHITE_SPACE_CHAR}`) ?? ''
  );
}

export function stripHtmlTags(string = '') {
  if (!string) {
    return '';
  }
  return string.replace(/<\/?[^>]+(>|$)/g, '');
}
